import { useRef } from "react";
import { ArrowLeft, ArrowRight, ArrowUpRight } from "lucide-react";
import { Eyebrow, MaskText } from "@/components/motion";
import { ProductCard } from "@/components/ProductCard";
import { BEST_SELLERS, collectionUrl } from "@/data/catalog";

export const BestSellers = () => {
  const track = useRef(null);
  const scroll = (dir) => track.current?.scrollBy({ left: dir * track.current.clientWidth * 0.75, behavior: "smooth" });
  return (
    <section id="bestsellers" data-testid="bestsellers-section" className="theme-light relative bg-ink py-24 text-cream lg:py-36">
      <div className="mx-auto mb-12 flex max-w-[1440px] flex-wrap items-end justify-between gap-6 px-5 sm:px-8 lg:px-12">
        <div>
          <Eyebrow>02 — Most loved</Eyebrow>
          <h2 className="mt-5 font-display text-5xl font-light leading-[0.95] text-cream sm:text-6xl lg:text-7xl">
            <MaskText lines={["Best sellers,", <em key="e" className="italic text-champagne">on repeat.</em>]} />
          </h2>
        </div>
        <div className="flex items-center gap-3">
          <a href={collectionUrl("best-sellers-beauty-edit")} data-testid="bestsellers-view-all" className="nav-link mr-3 inline-flex items-center gap-1 text-sm text-cream">
            View all <ArrowUpRight className="h-4 w-4" />
          </a>
          <button data-testid="bestsellers-prev" aria-label="Previous" onClick={() => scroll(-1)} className="icon-btn h-12 w-12"><ArrowLeft className="h-4 w-4" /></button>
          <button data-testid="bestsellers-next" aria-label="Next" onClick={() => scroll(1)} className="icon-btn h-12 w-12"><ArrowRight className="h-4 w-4" /></button>
        </div>
      </div>
      <div ref={track} data-testid="bestsellers-track" className="no-scrollbar flex snap-x snap-mandatory gap-4 overflow-x-auto scroll-px-5 px-5 pb-4 sm:gap-6 sm:scroll-px-8 sm:px-8 lg:scroll-px-12 lg:px-12">
        {BEST_SELLERS.map((p, i) => (
          <ProductCard key={p.id} p={p} i={i} testPrefix="bestseller" className="w-[74vw] shrink-0 snap-start sm:w-[320px] lg:w-[340px]" />
        ))}
      </div>
    </section>
  );
};
